/**
 * 图片字段归一化
 *
 * 后端因为历史数据格式不统一,同一个图片字段可能返回以下任意一种:
 *   1. JSON 数组字符串  '["https://a/1.jpg","https://a/2.jpg"]'
 *   2. 逗号分隔字符串    'bt_backup/a.jpg,bt_backup/b.jpg'  或  'https://a/1.jpg,https://a/2.jpg'
 *   3. 单个地址字符串    'https://a/1.jpg'
 *   4. 空值 / '[]' / 'null'
 *
 * 统一转成字符串数组,避免各处裸写 JSON.parse 在遇到非 JSON 格式时抛异常
 * (模板里抛异常会导致整个列表渲染失败)。
 */

/**
 * 把任意形态的图片字段转成字符串数组
 * @param {String|Array|Object} value
 * @returns {Array<String>}
 */
export function toImageList(value) {
  if (!value) return []

  // 已经是数组(部分场景后端会直接下发数组)
  if (Array.isArray(value)) {
    return value.filter(item => typeof item === 'string' && item.trim() !== '')
  }

  if (typeof value !== 'string') return []

  // MySQL 里 JSON 字段可能带转义反斜杠,统一去掉(与后端 str_replace('\\','') 一致)
  const raw = value.trim().replace(/\\/g, '')
  if (raw === '' || raw === '[]' || raw === 'null' || raw === '{}') return []

  // 格式一:JSON 数组字符串
  if (raw.charAt(0) === '[' || raw.charAt(0) === '{') {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) {
        return parsed.filter(item => typeof item === 'string' && item.trim() !== '')
      }
      if (typeof parsed === 'string' && parsed !== '') return [parsed]
      return []
    } catch (e) {
      // 不是合法 JSON,继续按普通字符串处理
    }
  }

  // 格式二/三:逗号分隔或单个地址
  return raw.split(',').map(item => item.trim()).filter(item => item !== '')
}

/**
 * 取第一张图片,用于列表页缩略图
 * @param {String|Array|Object} value
 * @returns {String} 没有图片时返回空字符串
 */
export function firstImage(value) {
  const list = toImageList(value)
  return list.length > 0 ? list[0] : ''
}